module.exports = "/img/_/_/_/assets/images/creeper/book/common//32.jpg?0398d2f507db8edc390dc59f701e8a15";